import React, { useEffect, useCallback, useState, useRef } from 'react';
import useStyles from './styles';
import { Box, Typography, Select, MenuItem, Slider } from 'app/design';

import { matchSorter } from 'match-sorter';

import { sortBy, cloneDeep } from 'lodash';
import { useWebphoneContext } from '../../../Store';
import { useWebphoneSelector } from 'app/data/webphone';

const MicSetting = props => {
  const { filterText, setFilterMatching } = props;

  const SUB_ITEMS = [
    {
      component: MicDevice,
    },
    {
      component: MicVolume,
    },
  ];

  const [fullSubitemsList, setFullSubitemsList] = useState([...SUB_ITEMS]);

  const anyChildrenMatch = fullSubitemsList.find(setting => setting.matching)
    ? true
    : false;

  useEffect(() => {
    setFilterMatching(anyChildrenMatch);
  }, [fullSubitemsList, anyChildrenMatch]);

  const handleChildrenFilterMatching = index => matching => {
    setFullSubitemsList(list => {
      list[index].matching = matching;
      return [...list];
    });
  };

  const classes = useStyles({ anyChildrenMatch });

  return (
    <Box sx={classes.mainCategory}>
      <Typography variant="h6" bold gutterBottom>
        Microphone
      </Typography>
      <div style={{ padding: '0px 8px' }}>
        {SUB_ITEMS.map((subitem, i) => {
          const Component = subitem.component;
          return (
            <Component
              key={i}
              filterText={filterText}
              setFilterMatching={handleChildrenFilterMatching(i)}
            />
          );
        })}
      </div>
    </Box>
  );
};

const MicDevice = props => {
  const { filterText, setFilterMatching } = props;
  const [state, dispatch] = useWebphoneContext();
  const { mediaDevices, changeAudioInput, getPreferredDevice } = state;

  const [doesMatch, setDoesMatch] = useState(true);
  const [selectedDevice, setSelectedDevice] = useState('default');

  useEffect(() => {
    setFilterMatching(doesMatch);
  }, [doesMatch]);

  useEffect(() => {
    const matches = ['microphone input device'];
    setDoesMatch(matchSorter(matches, filterText).length ? true : false);
  }, [filterText]);

  let audioInDevices = [];
  if (mediaDevices !== undefined) {
    audioInDevices = mediaDevices.filter(item => item.kind === 'audioinput');
    if (audioInDevices.length === 1) {
      if (selectedDevice !== audioInDevices[0].deviceId) {
        setSelectedDevice(audioInDevices[0].deviceId);
      }
    } else {
      const device = getPreferredDevice('audioinput');
      if (device !== selectedDevice) {
        setSelectedDevice(device);
      }
    }
  }
  const onDeviceChange = id => {
    changeAudioInput(id);
    setSelectedDevice(id);
  };

  const classes = useStyles({ doesMatch });

  return (
    <Box sx={classes.subitem}>
      <div style={{}}>
        <Typography variant="body1" gutterBottom>
          Input Device
        </Typography>
        <Select
          size="small"
          style={{ width: '100%' }}
          value={selectedDevice}
          onChange={e => onDeviceChange(e.target.value)}
        >
          {audioInDevices.map((deviceInfo, i) => (
            <MenuItem key={i} value={deviceInfo.deviceId}>
              {deviceInfo.label}
            </MenuItem>
          ))}
        </Select>
      </div>
    </Box>
  );
};

const MicVolume = props => {
  const { filterText, setFilterMatching } = props;
  const [state, dispatch] = useWebphoneContext();
  const { calls, mediaDevices, setMicVolume, getMicVolume } = state;

  const [doesMatch, setDoesMatch] = useState(true);
  const [volume, setVolume] = useState(100);

  useEffect(() => {
    setFilterMatching(doesMatch);
  }, [doesMatch]);

  useEffect(() => {
    const matches = ['microphone volume'];
    setDoesMatch(matchSorter(matches, filterText).length ? true : false);
  }, [filterText]);

  let micVol = getMicVolume() * 100;
  micVol = Math.round(micVol);
  if (micVol !== volume) {
    setVolume(micVol);
  }
  const onVolumeChange = (event, value) => {
    const vol = Math.round(value) / 100;
    setMicVolume(vol);
    setVolume(Math.round(value));
  };
  const classes = useStyles({ doesMatch });

  return (
    <Box sx={classes.subitem}>
      <div style={{}}>
        <Typography variant="body1">Input Volume</Typography>
        <Typography variant="caption" component="div" gutterBottom>
          (how loud you sound to others)
        </Typography>
        <span>{volume}%</span>
        <Slider value={volume} onChange={onVolumeChange} />
      </div>
    </Box>
  );
};

export default MicSetting;
